import React from 'react';
import './PrintSheet.css';

export default function PrintSheet({ children, hidden = false, questionPage = false }) {
    return <div className="diagramacao-print-sheet" hidden={hidden}>
        <div className={`diagramacao-print-sheet-canvas${questionPage ? ' is-question-page' : ''}`}>{children}</div>
    </div>;
}
